import { h } from 'preact';

import style from './style.css';


const Footer = () => (

    <footer id="footer" class={style.footer}>
        <div class="footer-top">
            <div class="container">
                <div class="row">

                    <div class="col-lg-3 col-md-6 footer-info">
                        <h3>MKS Company</h3>
                        <p><a href="https://myworkspace.vn/portal" target="_blank">MyWorkspace</a> is our services.<br/>Make your work better!</p>
                    </div>

                    <div class="col-lg-3 col-md-6 footer-links">
                        <h4>Links</h4>
                        <ul>
                            <li><i class="ion-ios-arrow-right"> </i> <a href="#">Home</a></li>
                            <li><i class="ion-ios-arrow-right"> </i> <a href="#">About us</a></li>
                            <li><i class="ion-ios-arrow-right"> </i> <a href="#">Services</a></li>
                            {/* <li><i class="ion-ios-arrow-right"> </i> <a href="#">Điều khoản dịch vụ</a></li>
                            <li><i class="ion-ios-arrow-right"> </i> <a href="#">Chính sách bảo mật</a></li> */}
                        </ul>
                    </div>

                    <div class="col-lg-3 col-md-6 footer-contact">
                        <h4>Contact</h4>
                        <p>
                            10A Stree 182 <br />
              Tang Nhon Phu A Ward<br />
              Thu Duc City, HoChiMinh City <br />
                            <strong>Phone:</strong> +084 977 548345<br />
                            <strong>Email:</strong> ThachLN@mks.com.vn<br />
                        </p>

                        <div class="social-links">
                            <a href="#" class="twitter"><i class="fa fa-twitter"> </i></a>
                            <a href="#" class="facebook"><i class="fa fa-facebook"> </i></a>
                            <a href="#" class="instagram"><i class="fa fa-instagram"> </i></a>
                            <a href="#" class="google-plus"><i class="fa fa-google-plus"> </i></a>
                            <a href="#" class="linkedin"><i class="fa fa-linkedin"> </i></a>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-6 footer-newsletter">
                        <h4>Message</h4>
                        <p>Make your work better is our mission.</p>
                        {/* <form action="" method="post">
                            <input type="email" name="email" /><input type="submit" value="Đăng ký" />
                        </form> */}
                    </div>

                </div>
            </div>
        </div>

        <div class="container">
            <div class="copyright">
                &copy; Copyright <strong>MKS</strong>.
      </div>
            <div class="credits">
                {/* <!--
          All the links in the footer should remain intact.
          You can delete the links only if you purchased the pro version.
          Licensing information: https://bootstrapmade.com/license/
          Purchase the pro version with working PHP/AJAX contact form: https://bootstrapmade.com/buy/?theme=BizPage
        --> */}
        {/* Powerby <a href="https://bootstrapmade.com/">BootstrapMade</a> */}
      </div>
        </div>
    </footer>

);
export default Footer;
